import { useStoredInspection } from './useStoredInspection';
import { InspectionOwner } from '@/enums/InspectionOwner.enum';

export const useCanOpenInspection = (inspectionId?: string): boolean => {
    const storedInspection = useStoredInspection(inspectionId);
    return !storedInspection?.locked || storedInspection?.locked?.by === InspectionOwner.UI;
}; 